import { render, staticRenderFns } from "./package-images.vue?vue&type=template&id=71445cca&scoped=true&"
import script from "./package-images.vue?vue&type=script&lang=js&"
export * from "./package-images.vue?vue&type=script&lang=js&"
import style0 from "./package-images.vue?vue&type=style&index=0&id=71445cca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71445cca",
  null
  
)

export default component.exports